import moment from "moment"
import Service from "../../../Services/index";

const invoicePayoff = {
    namespaced: true,
    state: {
        customers: [],
        invoicePayoffList: [],
        invoice_payoff_other_list: [],
        transactions: {
            cash: {
                transaction_type_id: 3,
                cheque_bank_id: null,
                ref_no: "",
                date: "",
                bank_name: "",
                bank_branch: "",
                bank_branch_id: "",
                amount: "",
                bank: null,
                bank_id: "",
                remark: ""
            },
            cheque: [{
                transaction_type_id: 1,
                cheque_bank_id: null,
                ref_no: "",
                date: "",
                bank_name: "",
                bank_branch: "",
                bank_branch_id: "",
                amount: "",
                bank: null,
                bank_id: "",
                remark: ""
            }],
            transfer: [{
                transaction_type_id: 2,
                cheque_bank_id: null,
                ref_no: "",
                date: "",
                bank_name: "",
                bank_branch: "",
                bank_branch_id: "",
                amount: "",
                bank: null,
                bank_id: "",
                remark: ""
            }],
            checkCash: false,
            checkCheque: false,
            checkTransfer: false,
            checkClose: false,
            closeRemark: ''
        },
        form: {
            id: "",
            payoff_number: "",
            payoff_number_history: "",
            rvo_number: "",
            payoff_status_id: "",
            date: "",
            user_id: "",
            draft_user_id: "",
            customer_id: "",
            billing_id: "",
            total: 0,
            balance: 0,
            amount: 0,
            is_sell: "",
            acc: "",
            pledge_amount: "",
            fee_amount: "",
            overpay: "",
            arrears: "",
            sale: null,
            customer: [],
            billing: [],
            transactions: [],
            details: [],
            other_details: [],
            checkbox_invoice: [],
            remark: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        dataPaginateOther: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            invoice: null,
            invoice_id: '',
            date: [],
            customer: null,
            /*add search 8/4/63*/
            billing: null,
            rv_number: null,
            rv_status: null,
            amount: '',
        },
        billings: [],
    },
    mutations: {
        GET_INVOICE_PAYOFF: (state, res) => {
            state.invoicePayoffList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        GET_BILLING_PAYOFF: (state, res) => {
            state.billings = res;
        },
        GET_INVOICE_FROM_CUSTOMER: (state, res) => {
            state.form.amount = 0;
            state.form.details = res;
        },
        GET_INVOICE_PAYOFF_BY_ID: (state, data) => {
            //data
            state.form = data;
            //other_details
            if (data.other_details.length > 0) {
                state.form.other_details = data.other_details
                state.form.other_details.push(
                    {
                        account: null,
                        account_other_id: "",
                        amount: "",
                    })
            } else {
                state.form.other_details = [
                    {
                        account: null,
                        account_other_id: "",
                        amount: "",
                    }
                ]
            }
            //transactions
            state.transactions.checkCheque = false;
            state.transactions.checkCash = false;
            state.transactions.checkTransfer = false;
            state.transactions.cheque = [];
            state.transactions.transfer = [];
            state.transactions.cash = {
                transaction_type_id: 3,
                cheque_bank_id: null,
                ref_no: "",
                date: "",
                bank_name: "",
                bank_branch: "",
                bank_branch_id: "",
                amount: "",
                bank: null,
                bank_id: "",
            };
            if (data.transactions.length > 0) {
                data.transactions.forEach(transaction => {
                    if (transaction.transaction_type_id == 1) { //cheque
                        state.transactions.checkCheque = true;
                        state.transactions.cheque = [
                            ...state.transactions.cheque,
                            {
                                transaction_type_id: 1,
                                cheque_bank_id: transaction.cheque_bank_id,
                                ref_no: transaction.ref_no,
                                date: transaction.date,
                                bank_name: transaction.bank_name,
                                bank_branch: transaction.bank_branch,
                                bank_branch_id: transaction.bank_branch_id,
                                amount: transaction.amount,
                                bank: transaction.bank,
                                bank_id: transaction.bank_id,
                            }
                        ]
                    }
                    if (transaction.transaction_type_id == 2) { //transfer
                        state.transactions.checkTransfer = true;
                        state.transactions.transfer = [
                            ...state.transactions.transfer,
                            {
                                transaction_type_id: 2,
                                cheque_bank_id: transaction.cheque_bank_id,
                                ref_no: transaction.ref_no,
                                date: transaction.date,
                                bank_name: transaction.bank_name,
                                bank_branch: transaction.bank_branch,
                                bank_branch_id: transaction.bank_branch_id,
                                amount: transaction.amount,
                                bank: transaction.bank,
                                bank_id: transaction.bank_id,
                            }
                        ]
                    }
                    if (transaction.transaction_type_id == 3) { //cash
                        state.transactions.checkCash = true;
                        state.transactions.cash = {
                            transaction_type_id: 3,
                            cheque_bank_id: transaction.cheque_bank_id,
                            ref_no: transaction.ref_no,
                            date: transaction.date,
                            bank_name: transaction.bank_name,
                            bank_branch: transaction.bank_branch,
                            bank_branch_id: transaction.bank_branch_id,
                            amount: transaction.amount,
                            bank: transaction.bank,
                            bank_id: transaction.bank_id,
                        }
                    }
                })
            }
            ;
            //new data
            if (state.transactions.checkCash == false) {
                state.transactions.cash = {
                    transaction_type_id: 3,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }
            }
            if (state.transactions.cheque == false) {
                state.transactions.cheque = [{
                    transaction_type_id: 1,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }]
            }
            if (state.transactions.transfer == false) {
                state.transactions.transfer = [{
                    transaction_type_id: 2,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }]
            }
        },

        SET_INVOICE_PAYOFF_STATUS_ID: (state, payoff_status_id) => {
            state.form.payoff_status_id = payoff_status_id;
        },
        GET_CUSTOMER_FROM_SALE: (state, data) => {
            state.customers = data;
        },
        CLEAR_DATA_FORM: (state) => {
            let currentDate = moment().format("YYYY-MM-DD");
            state.form = {
                id: "",
                payoff_number: "",
                payoff_number_history: "",
                rvo_number: "",
                payoff_status_id: "",
                date: currentDate,
                user_id: "",
                customer_id: "",
                billing_id: "",
                total: 0,
                balance: 0,
                amount: 0,
                is_sell: "",
                acc: "",
                pledge_amount: "",
                fee_amount: "",
                overpay: "",
                arrears: "",
                sale: null,
                customer: [],
                billing: [],
                transactions: [],
                details: [],
                other_details: [{
                    account: null,
                    account_other_id: "",
                    amount: "",
                }],
                checkbox_invoice: [],
                remark: "",
            };
            state.billings = [];

        },

        CLEAR_SEARCH: (state) => {
            state.search = {
                invoice: null,
                invoice_id: '',
                date: [],
                customer: null,
                /*add search 8/4/63*/
                billing: null,
                rv_number: null,
                rv_status: null,
            }
        },
        CLEAR_TRANSACTION: (state) => {
            state.transactions = {
                cash: {
                    transaction_type_id: 3,
                    cheque_bank_id: null,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    bank: null,
                    bank_id: "",
                },
                cheque: [{
                    transaction_type_id: 1,
                    cheque_bank_id: null,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    bank: null,
                    bank_id: "",
                }],
                transfer: [{
                    transaction_type_id: 2,
                    cheque_bank_id: null,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    bank_branch_id: "",
                    amount: "",
                    bank: null,
                    bank_id: "",
                }],
                checkCash: false,
                checkCheque: false,
                checkTransfer: false,
            };
        },

        SET_DATA_FROM_INVOICE: (state, res) => {
            let currentDate = moment().format("YYYY-MM-DD");
            state.form = {
                id: "",
                payoff_number: "",
                payoff_number_history: "",
                payoff_status_id: "",
                date: currentDate,
                user_id: "",
                customer_id: "",
                billing_id: "",
                total: 0,
                balance: 0,
                amount: 0,
                is_sell: "",
                acc: "",
                pledge_amount: "",
                fee_amount: "",
                overpay: "",
                arrears: "",
                sale: "",
                customer: [],
                billing: [],
                transactions: [],
                details: [],
                other_details: [{
                    account: null,
                    account_other_id: "",
                    amount: "",
                }],
                checkbox_invoice: [],
                remark: "",
            };
            if (res) {
                state.form.sale = res.sale;
                state.form.customer = [
                    res.customer
                ];
                state.form.checkbox_invoice = [
                    res.id
                ];
            }
        },

        ADD_OTHER_DETAILS: state => {
            state.form.other_details = [
                ...state.form.other_details,
                {
                    account: null,
                    account_other_id: "",
                    amount: "",
                }
            ]
        },
        REMOVE_OTHER_DETAILS: (state, index) => {
            state.form.other_details = state.form.other_details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        GET_INVOICE_PAYOFF_OTHER: (state, res) => {
            state.invoice_payoff_other_list = res.data;
            state.dataPaginateOther = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
    },
    actions: {
        setInvoicePayoff: ({commit}, {page = 1, transaction_type_id}) => {
            return Service.invoicePayoff.getInvoicePayoff(page, transaction_type_id).then(res => {
                commit("GET_INVOICE_PAYOFF", res);
            })
        },
        showInvoicePayoff({commit}, id) {
            return Service.invoicePayoff.getInvoicePayoffById(id).then(data => {
                commit("GET_INVOICE_PAYOFF_BY_ID", data);
            })
        },
        setPayoffStatusId({commit}, data) {
            commit("SET_INVOICE_PAYOFF_STATUS_ID", data);
        },
        saveInvoicePayoff({commit}, {id, data}) {
            if (!id) {
                return Service.invoicePayoff.createInvoicePayoff(data)
            } else {
                return Service.invoicePayoff.updateInvoicePayoff(id, data);
            }
        },
        deleteInvoicePayoff({commit}, data) {
            return Service.invoicePayoff.deleteInvoicePayoff(data.page, data.id, data.remark).then(res => {
                //console.log("delete success");
            });
        },
        getCustomerFromSale({commit}, sale_id) {
            return Service.invoicePayoff.getCustomerFromSale(sale_id);
        },
        getInvoiceFormCustomer({commit}, data) {
            return Service.invoicePayoff.getInvoiceFormCustomer(data.customer_id, data.billing_id, data.invoice_id)
                .then(res => {
                    commit("GET_INVOICE_FROM_CUSTOMER", res);
                })
        },
        getBillingPayoff({commit}, data) {
            return Service.invoicePayoff.getBillingPayoff(data.sale_id, data.customer_id)
                .then(res => {
                    commit("GET_BILLING_PAYOFF", res);
                })
        },
        clearDataForm({commit}) {
            commit("CLEAR_DATA_FORM");
        },
        clearTransaction({commit}) {
            commit("CLEAR_TRANSACTION");
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        saveCreditCustomer({commit}, data) {
            return Service.invoicePayoff.saveCreditCustomer(data);
        },
        savePayoffCreditCustomer({commit}, data) {
            return Service.invoicePayoff.savePayoffCreditCustomer(data);
        },
        searchPayoff({commit}, {page = 1, data}) {
            return Service.invoicePayoff.searchInvoicePayoff(page, data).then(res => {
                commit("GET_INVOICE_PAYOFF", res);
            });
        },
        setDataFromInvoice({commit}, invoice_id) {
            //console.log("invoice_id",invoice_id);
            return Service.invoice.showInvoice(invoice_id).then(data => {
                commit("SET_DATA_FROM_INVOICE", data)
            });
        },
        generateRV() {
            return Service.invoicePayoff.generateRV();
        },
        updateRv({commit}, data) {
            return Service.invoicePayoff.updateRv(data);
        },
        approveStatus({commit}, {id, data}) {
            return Service.invoicePayoff.approveStatus(id, data);
        },
        printInvoicePayoffById({commit}, {id, user_id}) {
            return Service.invoicePayoff.printPayoffById(id, user_id)
        },
        validateInvoicePayoff({commit}, data) {
            return Service.invoicePayoff.validateRvNumber(data.rv_number, data.id);
        },
        //invoice_payoff_other Details
        addOtherDetails({commit}) {
            commit("ADD_OTHER_DETAILS");
        },
        removeOtherDetails({commit}, index) {
            commit("REMOVE_OTHER_DETAILS", index);
        },
        getInvoicePayoffOtherList({commit}, page = 1) {
            return Service.InvoicePayoffOther.getInvoicePayoffOther(page).then(res => {
                commit("GET_INVOICE_PAYOFF_OTHER", res)
            })
        },
        showInvoicePayoffOther({commit}, id) {
            return Service.InvoicePayoffOther.showInvoicePayoffOther(id).then(res => {
                commit("GET_INVOICE_PAYOFF_BY_ID", res);
            })
        },
        deleteInvoicePayoffOther({commit}, id) {
            return Service.InvoicePayoffOther.deleteInvoicePayoffOther(id)
        },
        saveOtherDetails({}, {id, data}) {
            if (!id) {
                return Service.InvoicePayoffOther.createInvoicePayoffOther(data)
            } else {
                return Service.InvoicePayoffOther.updateInvoicePayoffOther(id, data)
            }
        },
        searchInvoiceOther({commit}, data) {
            return Service.InvoicePayoffOther.searchInvoicePayoffOther(data).then(res => {
                commit("GET_INVOICE_PAYOFF_OTHER", res)
            })
        },
        printInvoicePayoffOther({commit}, {id, user}) {
            return Service.InvoicePayoffOther.printInvoicePayoffOther(id, user);
        },

    }
};

export default invoicePayoff
